var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMhoLeftArrowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 9,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67053 0.334686C9.10535 0.776398 9.10986 1.48972 8.68402 1.93701L8.67053 1.95093 2.71606 7.99994 8.67053 14.049C9.10535 14.4907 9.10986 15.204 8.68402 15.6513L8.67053 15.6652C8.23572 16.1069 7.53357 16.1115 7.09326 15.6789L7.07959 15.6652 0.32959 8.80807C-0.105225 8.36636-0.109741 7.65302 0.316101 7.20572L0.32959 7.1918 7.07959 0.334686C7.51892-0.111633 8.2312-0.111633 8.67053 0.334686Z",
    fill: "#023860"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMhoLeftArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mho-left-arrow-icon.b282a775b2679ab595034b2d0cb8bd31.svg";